import { HEAP_ENVS } from 'constants/heap';
import { windowUtils } from 'utils/windowUtils/windowUtils';
import { Heap } from './Heap/Heap';

function AnalyticsHeap() {
  const shouldInitHeap = HEAP_ENVS.includes(windowUtils.getHostname());
  if (shouldInitHeap) {
    Heap.initialize();
  }
  return null;
}

export { AnalyticsHeap };
